import React from 'react';

import { ButtonText, LogoWrapper, SsoButtonWrapper } from './SsoButton-styled-components';

interface SsoButtonProps {
  name: string;
  logo: React.ReactNode;
  onClick: () => void;
}

export const SsoButton = ({ name, logo, onClick }: SsoButtonProps) => {
  return (
    <SsoButtonWrapper onClick={onClick}>
      <LogoWrapper>
        {logo}
      </LogoWrapper>
      <ButtonText>
        {name}
      </ButtonText>
    </SsoButtonWrapper>
  );
};
